module.exports = __webpack_public_path__ + "img/google.5082cea6.svg";